import moment from 'moment';
import { TIME_LOCALE } from '../constants';

moment.locale('pt-br');
moment.updateLocale('pt-br', TIME_LOCALE);

export function formatDate(date) {
  return moment(date).format('DD/MM/YYYY');
}

export function getTotalInDays(initalDate, finalDate) {
  return moment(finalDate).diff(initalDate, 'days');
}

export function getDuration(initalDate, finalDate) {
  return moment
    .duration(moment(finalDate).diff(initalDate, 'days'), 'days')
    .humanize();
}
